import http from "@/utils/axios";
import cookie from "@/utils/cookie";

const state = {
  searchCondition: {
    name: '',
    parentId: '',
  },
  //机构的基本信息
  department: {},
  //tree格式的dept数据
  treeDeptData: [],
  memberDepartmentRlnS: [],
  deptListDataPage: 0,
  currentPage: 1,
}

const mutations = {

  //加载部门的tree格式的数据
  loadingTreeDeptData(state) {
    let obj = {
      token: cookie.getCookie('token'),
      data: {
        pageSize: -1,
      }
    }
    let response = http.post(window.config.api.baseUrl + '/eims-api/department/findCurrentAndSub', obj)
    response.then(value => {
      if (value.data.code === '00000') {
        state.treeDeptData = value.data.data.departments
      }
    })
    return response
  },

  findMemberDepartmentInfo(state, obj) {
    http.post(window.config.api.baseUrl + '/eims-api/memberDept/list', obj).then(value => {
      if (value.data.code === '00000') {
        state.deptListDataPage = value.data.data.total
        state.memberDepartmentRlnS = value.data.data.memberDepartmentRlnS;
        //缓存查询条件
        state.searchCondition.name = obj.data.name
        state.searchCondition.parentId = obj.data.parentId
      }
    })
  },

  //清空缓存数据
  clearDeptListData(state, obj) {
    state.searchCondition.name = ''
    state.treeDeptData = []
    state.memberDepartmentRlnS = []
    state.deptListDataPage = 0
    state.currentPage = 1
  },

  clearMemberDeptData(state, obj) {
    state.memberDepartmentRlnS = []
  },

}

const actions = {
  //加载部门的tree格式的数据
  loadingTreeDeptData: ({commit, state}) => {
    commit('loadingTreeDeptData')
  },

  //查询部门的结果数据
  findMemberDepartmentInfo: ({commit, state}, obj) => {
    commit('findMemberDepartmentInfo', obj)
  },

  //清空机构数据
  clearDeptListData: ({commit, state}, obj) => {
    commit('clearDeptListData', obj)
  },

  clearMemberDeptData: ({commit, state}, obj) => {
    commit('clearMemberDeptData', obj)
  },

}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/memberDepartmentModule.js